"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.IInvoice = exports.InvoiceFrequency = exports.PDFStatus = exports.IProductizedBy = exports.IInvoicedBy = exports.IInvoiceStatus = void 0;
const openapi_1 = require("../../../openapi");
const IInvoicePayrixTransactions_1 = require("./IInvoicePayrixTransactions");
var IInvoiceStatus;
(function (IInvoiceStatus) {
    IInvoiceStatus["UNPUBLISHED"] = "unpublished";
    IInvoiceStatus["PUBLISHED"] = "published";
    IInvoiceStatus["PAID"] = "paid";
})(IInvoiceStatus = exports.IInvoiceStatus || (exports.IInvoiceStatus = {}));
var IInvoicedBy;
(function (IInvoicedBy) {
    IInvoicedBy["ALL"] = "all";
    IInvoicedBy["TRANSACTION"] = "transaction";
    IInvoicedBy["TRANSACTION_TYPE"] = "transactionType";
    IInvoicedBy["CATEGORY"] = "category";
    IInvoicedBy["WAREHOUSE"] = "warehouse";
})(IInvoicedBy = exports.IInvoicedBy || (exports.IInvoicedBy = {}));
var IProductizedBy;
(function (IProductizedBy) {
    IProductizedBy["ALL"] = "all";
    IProductizedBy["TRANSACTION_TYPE"] = "transactionType";
    IProductizedBy["CATEGORY"] = "category";
})(IProductizedBy = exports.IProductizedBy || (exports.IProductizedBy = {}));
var PDFStatus;
(function (PDFStatus) {
    PDFStatus["DONE"] = "done";
    PDFStatus["IN_PROGRESS"] = "inProgress";
    PDFStatus["FAILED"] = "failed";
})(PDFStatus = exports.PDFStatus || (exports.PDFStatus = {}));
var InvoiceFrequency;
(function (InvoiceFrequency) {
    InvoiceFrequency["WEEKLY"] = "weekly";
    InvoiceFrequency["BIWEEKLY"] = "biweekly";
    InvoiceFrequency["MONTHLY"] = "monthly";
    InvoiceFrequency["DAILY"] = "daily";
})(InvoiceFrequency = exports.InvoiceFrequency || (exports.InvoiceFrequency = {}));
class IInvoice {
    id;
    orgKey;
    customerId;
    customerName;
    number;
    total;
    chargeCount;
    created;
    unpublishDate;
    publishDate;
    dueDate;
    paidDate;
    status;
    invoicedBy;
    productizedBy;
    poNumber;
    trailerNumber;
    bolNumber;
    referenceNumber;
    transactionId;
    trackingNumber;
    pdfStatus;
    reportingDate;
    payrixTransaction;
    summary;
    paidBy;
}
__decorate([
    (0, openapi_1.Schema)({ type: 'string', format: 'uuid' })
], IInvoice.prototype, "id", void 0);
__decorate([
    (0, openapi_1.Schema)({ type: 'string', format: 'uuid' })
], IInvoice.prototype, "orgKey", void 0);
__decorate([
    (0, openapi_1.Schema)({ type: 'string', format: 'uuid' })
], IInvoice.prototype, "customerId", void 0);
__decorate([
    (0, openapi_1.Schema)({ type: 'string' })
], IInvoice.prototype, "customerName", void 0);
__decorate([
    (0, openapi_1.Schema)({ type: 'string' })
], IInvoice.prototype, "number", void 0);
__decorate([
    (0, openapi_1.Schema)({ type: 'number' })
], IInvoice.prototype, "total", void 0);
__decorate([
    (0, openapi_1.Schema)({ type: 'number' })
], IInvoice.prototype, "chargeCount", void 0);
__decorate([
    (0, openapi_1.Schema)({ type: 'number' })
], IInvoice.prototype, "created", void 0);
__decorate([
    (0, openapi_1.Optional)(),
    (0, openapi_1.Schema)({ type: 'number' })
], IInvoice.prototype, "unpublishDate", void 0);
__decorate([
    (0, openapi_1.Optional)(),
    (0, openapi_1.Schema)({ type: 'number' })
], IInvoice.prototype, "publishDate", void 0);
__decorate([
    (0, openapi_1.Schema)({ type: 'number' })
], IInvoice.prototype, "dueDate", void 0);
__decorate([
    (0, openapi_1.Optional)(),
    (0, openapi_1.Schema)({ type: 'number' })
], IInvoice.prototype, "paidDate", void 0);
__decorate([
    (0, openapi_1.Schema)({ type: 'string', enum: Object.values(IInvoiceStatus) })
], IInvoice.prototype, "status", void 0);
__decorate([
    (0, openapi_1.Schema)({ type: 'string', enum: Object.values(IInvoicedBy) })
], IInvoice.prototype, "invoicedBy", void 0);
__decorate([
    (0, openapi_1.Schema)({ type: 'string', enum: Object.values(IProductizedBy) })
], IInvoice.prototype, "productizedBy", void 0);
__decorate([
    (0, openapi_1.Optional)(),
    (0, openapi_1.Schema)({ type: 'string' })
], IInvoice.prototype, "poNumber", void 0);
__decorate([
    (0, openapi_1.Optional)(),
    (0, openapi_1.Schema)({ type: 'string' })
], IInvoice.prototype, "trailerNumber", void 0);
__decorate([
    (0, openapi_1.Optional)(),
    (0, openapi_1.Schema)({ type: 'string' })
], IInvoice.prototype, "bolNumber", void 0);
__decorate([
    (0, openapi_1.Optional)(),
    (0, openapi_1.Schema)({ type: 'string' })
], IInvoice.prototype, "referenceNumber", void 0);
__decorate([
    (0, openapi_1.Optional)(),
    (0, openapi_1.Schema)({ type: 'number' })
], IInvoice.prototype, "transactionId", void 0);
__decorate([
    (0, openapi_1.Optional)(),
    (0, openapi_1.Schema)({ type: 'string' })
], IInvoice.prototype, "trackingNumber", void 0);
__decorate([
    (0, openapi_1.Optional)(),
    (0, openapi_1.Schema)({ type: 'string', enum: Object.values(PDFStatus) })
], IInvoice.prototype, "pdfStatus", void 0);
__decorate([
    (0, openapi_1.Optional)(),
    (0, openapi_1.Schema)({ type: 'number' })
], IInvoice.prototype, "reportingDate", void 0);
__decorate([
    (0, openapi_1.Optional)(),
    (0, openapi_1.Schema)(() => IInvoicePayrixTransactions_1.IInvoicePayrixTransaction)
], IInvoice.prototype, "payrixTransaction", void 0);
__decorate([
    (0, openapi_1.Optional)(),
    (0, openapi_1.Schema)({ type: 'object' })
], IInvoice.prototype, "summary", void 0);
__decorate([
    (0, openapi_1.Optional)(),
    (0, openapi_1.Schema)({ type: 'string' })
], IInvoice.prototype, "paidBy", void 0);
exports.IInvoice = IInvoice;
